import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  Legend,
} from "recharts";

const MoneyOutBarChart = ({ statementData, loading }) => {
  if (loading) {
    return (
      <div className="w-full h-[500px] flex items-center justify-center bg-white rounded-[20px]">
        <span className="text-gray-500 text-lg">Loading chart data...</span>
      </div>
    );
  }

  const summary = statementData?.data?.summary || {};

  // Helper function to safely parse numbers from strings with commas
  const parseAmount = (value) => {
    if (!value) return 0;
    return Number(value?.toString()?.replace(/,/g, ""));
  };

  const moneyOutData = [
    {
      category: "Pay Bills",
      amount: parseAmount(summary["LIPA NA M-PESA (PAYBILL)"]),
    },
    {
      category: "Merchant Payments",
      amount: parseAmount(summary["LIPA NA M-PESA (BUY GOODS)"]),
    },
    {
      category: "Customer Transfer",
      amount: parseAmount(summary["SEND MONEY"]),
    },
    {
      category: "Customer Withdrawal",
      amount: parseAmount(summary["AGENT WITHDRAWAL"]),
    },
    {
      category: "Airtime Purchase",
      amount: parseAmount(summary["AIRTIME PURCHASE TOTALS"]),
    },
    {
      category: "Data Bundles",
      amount: parseAmount(summary["DATA BUNDLES TOTALS"]),
    },
    {
      category: "Mobile Loans / Debt Payment",
      amount: parseAmount(summary["LOAN TOTALS"]),
    },
    { category: "Fuliza", amount: parseAmount(summary["FULIZA TOTALS"]) },
  ];

  // If all values are zero, show a "No data" placeholder
  const allZero = moneyOutData?.every((d) => d?.amount === 0);
  if (allZero) {
    return (
      <div className="w-full h-[500px] flex items-center justify-center bg-white rounded-[20px]">
        <span className="text-gray-500 text-lg">
          No money-out data available
        </span>
      </div>
    );
  }

  const maxValue = Math?.max(...moneyOutData?.map((d) => d?.amount)) * 1.1;

  return (
    <ResponsiveContainer width="100%" height={500}>
      <BarChart
        data={moneyOutData}
        margin={{ top: 30, right: 30, left: 40, bottom: 90 }}
        barCategoryGap={20}
      >
        <XAxis
          dataKey="category"
          angle={-45}
          textAnchor="end"
          interval={0}
          height={90}
          tick={{ fontSize: 12 }}
        />

        <YAxis
          domain={[0, maxValue]}
          tickFormatter={(v) => (v / 1000)?.toLocaleString() + "K"}
          allowDecimals={false}
        />

        <Tooltip
          formatter={(v) =>
            Number(v)?.toLocaleString("en-US", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })
          }
        />

        <Legend
          verticalAlign="bottom"
          align="center"
          wrapperStyle={{ bottom: 20 }}
          payload={[
            { value: "Money Out (KES)", type: "square", color: "#ff5a5a" },
          ]}
          formatter={(value) => (
            <span style={{ color: "#000000" }}>{value}</span>
          )}
        />

        <Bar dataKey="amount" fill="#ff5a5a" barSize={45} />
      </BarChart>
    </ResponsiveContainer>
  );
};

export default MoneyOutBarChart;
